export const CanvasAllocate = Symbol.for('CanvasAllocate');
export const RectAllocate = Symbol.for('RectAllocate');
export const ArcAllocate = Symbol.for('ArcAllocate');
export const AreaAllocate = Symbol.for('AreaAllocate');
export const CircleAllocate = Symbol.for('CircleAllocate');
export const LineAllocate = Symbol.for('LineAllocate');
export const PathAllocate = Symbol.for('PathAllocate');
export const SymbolAllocate = Symbol.for('SymbolAllocate');
export const TextAllocate = Symbol.for('TextAllocate');
